export const MANUALS_SCHEMA = {
 "@context": "https://schema.org",
 "@graph": [
  {
   "@type": "Organization",
   "@id": "https://everest.ind.br/pt#organization",
   "name": "Everest Refrigeração Indústria e Comércio",
   "url": "https://everest.ind.br/pt",
   "logo": {
    "@type": "ImageObject",
    "url": "https://everest.ind.br/assets/images/logo-slogan.png",
    "contentUrl": "https://everest.ind.br/assets/images/logo-slogan.png"
   }
  },
  {
   "@type": "WebSite",
   "@id": "https://everest.ind.br/pt#website",
   "url": "https://everest.ind.br/pt",
   "name": "Everest | Purificadores e Máquinas de Gelo",
   "publisher": {
    "@id": "https://everest.ind.br/pt#organization"
   },
   "inLanguage": "pt-BR",
   "potentialAction": {
    "@type": "SearchAction",
    "target": "https://everest.ind.br/pt?s={search_term_string}",
    "query-input": "required name=search_term_string"
   }
  },
  {
   "@type": "CollectionPage",
   "@id": "https://everest.ind.br/pt/manuais#webpage",
   "url": "https://everest.ind.br/pt/manuais",
   "name": "Manuais Everest | Purificadores e Máquinas de Gelo",
   "description": "Acesse todos os manuais de instrução dos produtos Everest: purificadores de água e máquinas de gelo.",
   "inLanguage": "pt-BR",
   "isPartOf": {
    "@id": "https://everest.ind.br/pt#website"
   },
   "about": {
    "@id": "https://everest.ind.br/pt#organization"
   },
   "breadcrumb": {
    "@id": "https://everest.ind.br/pt/manuais#breadcrumb"
   },
   "primaryImageOfPage": {
    "@type": "ImageObject",
    "url": "https://everest.ind.br/assets/images/manuais.jpg"
   }
  },
  {
   "@type": "BreadcrumbList",
   "@id": "https://everest.ind.br/pt/manuais#breadcrumb",
   "itemListElement": [
    {
     "@type": "ListItem",
     "position": 1,
     "name": "Home",
     "item": "https://everest.ind.br/pt"
    },
    {
     "@type": "ListItem",
     "position": 2,
     "name": "Manuais",
     "item": "https://everest.ind.br/pt/manuais"
    }
   ]
  }
 ]
}
